// extracted by mini-css-extract-plugin
module.exports = {"donate":"block-module--donate--3EoPP","title":"block-module--title--1PFBH","text":"block-module--text--11Aq_","buttons":"block-module--buttons--3yeue"};